type EnvConfig = {
  KORINT_API_URL: string;
  COGNITO_USER_POOL_ID: string;
  COGNITO_USER_POOL_WEB_CLIENT_ID: string;
  STRIPE_PUBLISHABLE_KEY: string;
  TENANT_ID: string;
  PUBLIC_POSTHOG_KEY: string;
};

export const config: EnvConfig = {
  KORINT_API_URL: import.meta.env.VITE_KORINT_API_URL,
  COGNITO_USER_POOL_ID: import.meta.env.VITE_COGNITO_USER_POOL_ID,
  COGNITO_USER_POOL_WEB_CLIENT_ID: import.meta.env.VITE_COGNITO_USER_POOL_WEB_CLIENT_ID,
  TENANT_ID: import.meta.env.VITE_TENANT_ID,
  STRIPE_PUBLISHABLE_KEY: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY,
  PUBLIC_POSTHOG_KEY: import.meta.env.VITE_PUBLIC_POSTHOG_KEY,
};
